<template>
  <full-width>
    <h2
      class="text-2xl font-bold leading-9 tracking-tight text-center print:hidden tmsk-blue-text"
    >
      Pre-order Additional Masks
      <br />
      Payment Complete!
    </h2>
    <div
      class="flex flex-row items-center justify-center mt-6 space-x-4 print:hidden"
    >
      <div class="w-full max-w-lg px-4">
        <!-- Order Instance -->
        <div class="mx-1 tmsk-blue-border">
          <!-- Heading: Receipt # and tooltip -->
          <div class="flex justify-between px-4 py-2 text-white tmsk-blue-bg">
            <h1 class="font-bold">
              <!-- {{ txn.status === "exchanged" ? "Exchange" : "Receipt"}}:
                  {{ txn.uuid.split('-')[0] }} -->
              Receipt: {{ txn.uuid.split("-")[0] }}
            </h1>
            <div class="flex items-center justify-end float-right space-x-2">
              <button
                v-if="!isPayLahTile"
                class="p-1 bg-white rounded-full lg:block tmsk-blue-text"
                @click="printPage"
              >
                <svg
                  class="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"
                  ></path>
                </svg>
              </button>
              <tooltip color="white" height="h-auto">
                <p>
                  No refunds or exchanges after collection for hygiene reasons.
                  Please visit the
                  <a
                    target="_blank"
                    href="https://stayprepared.sg/masks-faq"
                    class="font-bold text-red-600 underline"
                  >
                    FAQ</a
                  >
                  section for more information.
                </p>
              </tooltip>
            </div>
          </div>
          <!-- Items -->
          <div v-for="item in txn.items" :key="item.sku">
            <div class="border-2 border-t-0 tmsk-blue-border">
              <!-- Items -->
              <div class="px-4 py-8 tmsk-blue-text tmsk-blue-border">
                <div class="mb-4 md:flex">
                  <!-- Details -->
                  <div
                    class="items-center justify-center block md:justify-start"
                  >
                    <img
                      :src="require(`@/assets/img/${item.sku}.png`)"
                      :alt="item.name"
                      class="w-1/2 mx-auto ie11-small-img md:w-4/5 md:ml-0"
                    />
                    <h2
                      class="w-full mx-auto my-4 text-xl font-bold text-center md:w-4/5 tmsk-blue-text md:mt-4 md:ml-0"
                    >
                      {{ item.name }}
                    </h2>
                  </div>
                  <!-- QR Code -->
                  <div class="relative w-full h-full">
                    <template
                      v-if="
                        (item.qtyUncollected === 0 &&
                          ['success', 'exchanged'].includes(txn.status)) ||
                        ['refunded'].includes(txn.status)
                      "
                    >
                      <div
                        class="absolute z-20 w-full h-full bg-white"
                        style="opacity: 0.9"
                      />
                      <p
                        class="absolute z-30 flex items-center justify-center w-full h-full text-2xl font-extrabold text-red-600"
                      >
                        <template
                          v-if="
                            item.qtyUncollected === 0 &&
                            ['success', 'exchanged'].includes(txn.status)
                          "
                        >
                          COLLECTED
                        </template>
                        <template v-else-if="['refunded'].includes(txn.status)">
                          REFUNDED
                        </template>
                      </p>
                    </template>
                    <div
                      class="flex items-center justify-center w-56 h-56 mx-auto sm:w-64 sm:h-64"
                    >
                      <canvas
                        class="absolute w-56 h-56 mx-auto sm:w-64 sm:h-64 canvas"
                      />
                      <qr-code
                        class="z-10 w-48 h-48 sm:w-56 sm:h-56"
                        level="Q"
                        :value="
                          (item.qtyUncollected === 0 &&
                            ['success', 'exchanged'].includes(txn.status)) ||
                          txn.status === 'refunded'
                            ? ''
                            : item.qr
                        "
                        renderAs="canvas"
                        :size="activeBreakpoint === 'sm' ? 192 : 224"
                      />
                    </div>
                  </div>
                </div>
                <p data-e2e-attr="checkout-sku-available-price">
                  <span class="font-bold">Price: </span>{{
                    txn.status === "exchanged"
                      ? "Not For Sale"
                      : `$${item.price.toFixed(2)}/mask (RRP: $${item.rrp.toFixed(2)}/mask)`}}
                </p>
                <p>
                  <span class="font-bold">Collected:</span>
                  {{ item.qtyTotal - item.qtyUncollected }} /
                  {{ item.qtyTotal }}
                </p>
                <p>
                  <span class="font-bold">Amount:</span>
                  {{
                    txn.status === "exchanged"
                      ? "Not For Sale"
                      : `$${(item.qtyTotal * item.price).toFixed(2)}`
                  }}
                </p>
                <p
                  v-if="txn.status === 'success' && !isCollected"
                  class="mt-6 text-red-700"
                >
                  No partial refund is allowed for this order.
                </p>
                <p class="mt-2 text-red-700"
                   data-e2e-attr="checkout-qrcode-collection">
                  Scan QR code to collect your mask from <span
                    data-e2e-attr="checkout-sku-available-location-text"
                    class="font-bold underline cursor-pointer"
                    @click="routeToLocateVM(item.sku)"
                  >over 800 locations island-wide.
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div class="flex justify-center px-4 py-2 text-white tmsk-blue-bg">
            <h1 class="font-bold">Total: ${{ totalAmount.toFixed(2) }}</h1>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="hasInit"
      class="w-full px-4 py-8 mt-8 print:hidden tmsk-blue-bg sm:px-16"
    >
      <div
        class="flex flex-col justify-center max-w-lg px-4 mx-auto space-y-2 text-white"
      >
        <h3 class="text-2xl font-bold text-center">COLLECTION END DATE:</h3>
        <h3 class="flex justify-center mb-4 text-2xl font-bold text-center">
          {{ collectionEndDate }}
          <tooltip color="white">
            <p>
              The last day for collection is Sun 23 Jan 11:59pm. Please collect
              all your masks by this date. No refunds or exchanges after
              collection for hygiene reasons.
            </p>
          </tooltip>
        </h3>
      </div>
      <div
        class="flex flex-row items-start max-w-lg px-6 mx-auto mt-6 justify-evenly"
      >
        <!-- <div class="flex flex-col items-center flex-1 space-y-2"> -->
        <button
          class="px-4 py-2 font-bold bg-white border rounded-full tmsk-blue-text tmsk-blue-border"
          @click="$router.push({ name: 'Purchase' })"
        >
          Order More
        </button>
        <!-- </div>
        <div class="flex flex-col items-center flex-1 space-y-2"> -->
        <button
          class="px-4 py-2 font-bold bg-white border rounded-full tmsk-blue-text tmsk-blue-border"
          @click="$router.push({ name: 'MyOrders' })"
        >
          See My Orders
        </button>
        <!-- </div> -->
      </div>
    </div>

    <printable-receipt :transaction="txn" />
  </full-width>
</template>

<script>
import FullWidth from '../../components/Layout/FullWidth'
import QrCode from 'qrcode.vue'
import Tooltip from '../../components/Tooltip'
import { mapState, mapGetters, mapActions } from 'vuex'
import beepAPI from '../../mixins/beepAPI'
import PrintableReceipt from '../../components/printableReceipt/PrintableReceipt'
import { COLLECTION_END_DATE } from '../../Constants'
import moment from 'moment'
export default {
  name: 'SuccessfulCheckout',
  metaInfo () {
    return {
      title: 'Successful Checkout',
      // meta: [
      //   { property: 'og:title', content: 'Successful Checkout' },
      //   { property: 'og:url', content: window.location.href },
      //   { property: 'og:site_name', content: 'Successful Checkout' },
      //   { property: 'og:image', content: 'https://s3-ap-southeast-1.amazonaws.com/mask.stayprepared.sg/assets/staymasked-og-04.jpg' }
      // ],
      link: [
        { rel: 'canonical', href: window.location.href }
      ]
    }
  },
  components: {
    FullWidth,
    // Card,
    QrCode,
    Tooltip,
    PrintableReceipt
  },
  mixins: [beepAPI],
  props: {},
  data () {
    return {
      hasInit: false,
      displayModal: false,
      modalData: null,
      skuSortOrder: [
        'SM6_MASK_M',
        'SM6_MASK_L'
      ]
    }
  },
  computed: {
    ...mapState(['purchasing', 'successfulPurchase', 'isPayLahTile']),
    ...mapGetters(['activeBreakpoint']),

    txn () {
      const transaction = this.successfulPurchase
      const sortedItems = []
      this.skuSortOrder.forEach((sku) => {
        const item = transaction.items.find(item => item.sku === sku)
        if (item) sortedItems.push(item)
      })

      transaction.items = sortedItems
      return transaction
    },

    title () {
      if (this.txn.status === 'exchanged') return 'Exchange'
      else if (this.txn.status === 'refunded') return 'Refund'
      return 'Receipt'
    },

    totalAmount () {
      // let total = 0
      // this.txn.items.forEach(({ price }) => {
      //   total += price
      // })

      // return total
      return this.successfulPurchase.amount
    }
  },
  watch: {},

  // Lifecycle Hooks
  beforeCreate () {},
  created () {
    this.collectionEndDate = moment(COLLECTION_END_DATE).format('DD MMM YYYY').toUpperCase()
  },
  beforeMount () {},
  mounted () {
    // TODO: Fetch products with quota
    if (!this.successfulPurchase) {
      this.$router.push({ name: 'Home', query: this.$route.query })
    } else {
      if (this.isPayLahTile) this.$router.replace({ query: { isPayLahTile: 'true' } })
      this.handleSuccessfulCheckoutInit()
    }
  },
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  beforeRouteLeave (to, from, next) {
    if (to.name === 'Checkout') {
      next({ name: 'Home', query: this.$route.query })
    } else {
      next()
    }
  },
  methods: {
    ...mapActions(['updateTransactionHistory', 'updateProducts']),

    printPage () {
      window.print()
    },

    handleFetchTransactionHistory () {
      return new Promise((resolve, reject) => {
        this.getTransactionHistory()
          .then(
            response => {
              this.updateTransactionHistory(response)
                .then(resolve)
            },
            error => {
              console.error(error)
              this.createModal({
                title: 'Something went wrong',
                message: 'Failed to fetch transaction history.',
                btnMessage: 'Proceed',
                callback: () => {}
              })
              reject(error)
            }
          )
      })
    },

    handleFetchProducts () {
      return new Promise((resolve, reject) => {
        this.getProducts()
          .then(
            response => {
              this.updateProducts(response)
                .then(resolve)
            },
            error => {
              console.error(error)
              this.createModal({
                title: 'Something went wrong',
                message: 'Failed to fetch products.',
                btnMessage: 'Proceed',
                callback: () => {}
              })
              reject(error)
            }
          )
      })
    },

    handleEmptyCart () {
      const body = {
        items: []
      }

      return new Promise((resolve, reject) => {
        this.putCart(body)
          .then(
            resolve,
            reject
          )
      })
    },

    handleSuccessfulCheckoutInit () {
      this.setIsLoading(true)

      Promise.all([
        this.handleFetchTransactionHistory(),
        this.handleFetchProducts(),
        this.handleEmptyCart()
      ])
        .then(() => {
          this.hasInit = true
          this.setIsLoading(false)
        })
        .then(this.paintCanvas)
    },

    isCollected () {
      // qtyUncollected > 0 = pending collection
      const uncollectedItem = this.txn.items.find(item => item.qtyUncollected > 0)
      if (uncollectedItem === undefined) return true
      else return false
    },

    redeem (txnStatus, item) {
      this.displayModal = true
      this.modalData = { txnStatus, ...item }
    },

    routeToLocateVM (sku) {
      this.$router.push({ path: `/locate-vending-machines/${sku}` })
    },

    paintCanvas () {
      var collection = document.querySelectorAll('.canvas')
      for (let i = 0; i < collection.length; i++) {
        const canvas = collection[i]
        const ctx = canvas.getContext('2d')
        ctx.fillStyle = 'white'
        ctx.fillRect(0, 0, canvas.width, canvas.height)
      }
    }
  }
}
</script>

<style scoped>
</style>
